<app-auth-layout>
  <app-sign-in-flow></app-sign-in-flow>
</app-auth-layout>
